<div class="activity-panel nt-flex nt-flex-col nt-flex-1" (click)="onPanelClick()">

  <!-- Header: Figma 2552:123535 -->
  <div class="activity-panel__header nt-flex nt-flex-col gap-4">
    <h3 class="activity-panel__title h3 no-margin">{{ 'STRINGS.ACTIVITY' | translate }}</h3>

    <!--
      Commented out, not deleted (AB#20613): the Figma panel has no close button; clicking the clock icon again or
      anywhere outside the panel closes it.
      <div class="tnp-close-button" (click)="onClosePanel()">
        <ic-activity-monitor-icon iconName="activity-close" [sizePx]="14"></ic-activity-monitor-icon>
      </div>
    -->

    <div class="activity-panel__toolbar nt-flex nt-flex-space-bw nt-align-items-center">
      <div class="activity-panel__menu-anchor">
        <button type="button" class="activity-panel__text-btn activity-panel__text-btn--dark h6 text-uppercase gap-4"
          [attr.aria-expanded]="showRangeMenu()"
          (click)="onToggleRangeMenu($event)">
          <span>{{ rangeLabel() | translate }}</span>
          <ic-icon-svg class="activity-panel__btn-icon" iconName="chevron-up-down"></ic-icon-svg>
        </button>

        @if (showRangeMenu()) {
          <div class="activity-panel__menu activity-panel__menu--range nt-flex nt-flex-col" role="menu" (click)="$event.stopPropagation()">
            @for (option of rangeOptions; track option.value) {
              <button type="button" role="menuitemradio"
                class="activity-panel__menu-item nt-flex nt-align-items-center gap-8"
                [class.mid-text]="option.value !== range()"
                [class.mid-text-bold]="option.value === range()"
                [class.activity-panel__menu-item--selected]="option.value === range()"
                [attr.aria-checked]="option.value === range()"
                (click)="onSelectRange(option.value)">
                {{ option.label | translate }}
              </button>
            }
          </div>
        }
      </div>

      <div class="activity-panel__menu-anchor">
        <button type="button" class="activity-panel__text-btn activity-panel__text-btn--blue h6 text-uppercase gap-4"
          [attr.aria-expanded]="showFilterMenu()"
          (click)="onToggleFilterMenu($event)">
          <span class="activity-panel__filter-icon">
            <ic-icon-svg class="activity-panel__btn-icon" iconName="filter"></ic-icon-svg>
            <!-- Some, not all, statuses ticked: same dot as the clock icon's new-activity dot -->
            @if (filterSelection() === 'partial') {
              <span class="activity-panel__filter-dot" aria-hidden="true"></span>
            }
          </span>
          <span>{{ 'STRINGS.FILTER' | translate }}</span>
        </button>

        @if (showFilterMenu()) {
          <!-- Report's Status filter items (Constants.ACTIVITY_STATUS_FILTER_ITEMS), on a white menu -->
          <div class="activity-panel__menu activity-panel__menu--filter nt-flex nt-flex-col" role="menu" (click)="$event.stopPropagation()">
            @for (status of statusItems; track status.key) {
              <label class="activity-panel__menu-item nt-flex nt-align-items-center gap-8">
                <input type="checkbox"
                  class="activity-panel__checkbox"
                  [checked]="statuses()[status.key]"
                  (change)="onToggleStatus(status.key, $any($event.target).checked)">
                <ic-activity-monitor-icon [iconName]="status.icon" [color]="status.color" [sizePx]="20"></ic-activity-monitor-icon>
                <span class="mid-text">{{ status.label | translate }}</span>
              </label>
            }
            <div class="activity-panel__menu-footer">
              @if (filterSelection() === 'none') {
                <button type="button" class="activity-panel__text-btn activity-panel__text-btn--blue h6 text-uppercase" (click)="onSelectAllStatuses()">
                  {{ 'STRINGS.SELECT_ALL' | translate }}
                </button>
              } @else {
                <button type="button" class="activity-panel__text-btn activity-panel__text-btn--blue h6 text-uppercase" (click)="onClearAllStatuses()">
                  {{ 'LABEL.CLEAR_ALL' | translate }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!--
      Commented out, not deleted (AB#20613): not in the Figma panel.
      <div class="tnp-header-row tnp-link-row" [class.disabled]="activities().length < 1">
        <a (click)="onDeleteAll()">{{ 'CASE_SENSITIVE.DELETE_ALL' | translate | titlecase }}</a>
        <span>{{'STRINGS.COUNT' | translate | titlecase}}: {{activities().length}}</span>
        <a (click)="onMarkAllRead()">{{ 'CASE_SENSITIVE.MARK_ALL_READ' | translate | titlecase }}</a>
      </div>
      <div id="tnp-load-new-btn" (click)="onRefresh()">
        <ic-activity-monitor-icon iconName="activity-load"></ic-activity-monitor-icon>
        <span class="prevent-select">{{'STRINGS.LOAD_NEW_ACTIVITIES' | translate | uppercase}}</span>
      </div>
    -->
  </div>

  <!-- List: Figma 2552:123543 -->
  <div class="activity-panel__list nt-flex nt-flex-col nt-flex-1">
    @if (!isLoading()) {
      @for (row of rows(); track row.key) {
        <div class="activity-panel__item nt-flex nt-flex-col gap-8">
          <div class="activity-panel__item-top nt-flex gap-8">
            <span class="activity-panel__controller h5 nt-flex-1">{{ row.controllerName }}</span>
            <span class="activity-panel__time small-text">{{ row.timestamp }}</span>
          </div>
          <div class="nt-flex gap-12">
            <ic-activity-monitor-icon class="activity-panel__icon" [iconName]="row.iconName" [sizePx]="24"></ic-activity-monitor-icon>
            <div class="nt-flex nt-flex-col nt-flex-1">
              <span class="activity-panel__item-title h5">{{ row.title }}</span>
              @if (row.message) {
                <span class="activity-panel__message p">{{ row.message }}</span>
              }
              @if (row.changes.length > 0) {
                @let expanded = expandedRows().has(row.key);
                <ul class="activity-panel__changes nt-flex nt-flex-col">
                  @for (change of (expanded ? row.changes : row.changes.slice(0, visibleChangeCount)); track $index) {
                    <li class="activity-panel__message">{{ change }}</li>
                  }
                </ul>
                @if (row.changes.length > visibleChangeCount) {
                  <button type="button" class="activity-panel__text-btn activity-panel__text-btn--blue activity-panel__more h6 text-uppercase"
                    [attr.aria-expanded]="expanded"
                    (click)="onToggleChanges(row.key)">
                    @if (expanded) {
                      {{ 'STRINGS.SHOW_LESS' | translate }}
                    } @else {
                      {{ 'VARIABLE_STRINGS.N_MORE' | translate: { count: row.changes.length - visibleChangeCount } }}
                    }
                  </button>
                }
              }
              <!--
                Mention, program/station tags and the action link (Figma 2552:123624, 6009:22774, 2552:123680) are styled
                in the .scss but not rendered: the report payload has no user, program or station fields yet. When it
                does: mention = .activity-panel__mention.small-text, tags = .activity-panel__tag.small-text.text-uppercase,
                action = <ic-icon-svg iconName="settings"> in an .activity-panel__text-btn--blue.h6.text-uppercase button.
              -->
            </div>
          </div>
        </div>
      }

      @if (rows().length === 0) {
        <p class="activity-panel__note no-margin">{{ emptyMessage() | translate }}</p>
      } @else if (noNewFilteredRows()) {
        <!-- The last Load More brought rows, but the ticked statuses hid all of them -->
        <p class="activity-panel__note no-margin">
          {{ (hasMore() ? 'PARAGRAPHS.NO_NEW_ACTIVITY_FOR_FILTERS' : 'STRINGS.NO_MORE_ACTIVITY_FOR_FILTERS') | translate }}
        </p>
      } @else if (!hasMore()) {
        <!-- End of the chosen range: say so, so the list does not just stop -->
        <p class="activity-panel__note no-margin">{{ endOfRangeMessage() | translate }}</p>
      }

      <!-- Figma 2552:125086: LOAD MORE after the last row; SEE MORE ACTIVITY once the chosen range is used up -->
      <div class="activity-panel__list-end nt-flex">
        @if (hasMore()) {
          <button type="button" class="activity-panel__text-btn activity-panel__text-btn--blue h6 text-uppercase gap-4"
            [disabled]="isLoadingMore()"
            (click)="onLoadMore()">
            <ic-icon-svg class="activity-panel__load-icon" iconName="arrow-clockwise" [svgResizable]="true"></ic-icon-svg>
            <span>{{ 'STRINGS.LOAD_MORE' | translate }}</span>
          </button>
        } @else {
          <button type="button" class="activity-panel__text-btn activity-panel__text-btn--blue h6 text-uppercase" (click)="onSeeMoreActivity()">
            <span>{{ 'STRINGS.SEE_MORE_ACTIVITY' | translate }}</span>
          </button>
        }
      </div>
    }
  </div>

  <!--
    Commented out, not deleted (AB#20613): the pre-Figma card list and footer Load More.
    <div id="tnp-scroll-wrapper">
      <div class="tnp-scroll-container">
        <div class="tnp-card-container">
          @if (activities().length < 1) {
            <ic-activity-card [isNoNotificationsCard]="true"></ic-activity-card>
          }
          @for (activity of activities(); track activity.id) {
            <ic-activity-card
              [activity]="activity"
              (activityDeleted)="onActivityDeleted($event)"
            ></ic-activity-card>
          }
        </div>
      </div>
    </div>
    <div id="tnp-footer">
      <div id="tnp-f-btn-container" [class.disabled]="isLoadMoreDisabled()" (click)="onLoadMore()">
        <ic-activity-monitor-icon iconName="activity-load" [color]="(isLoadMoreDisabled() ? 'lightgray' : null)"></ic-activity-monitor-icon>
        <span class="prevent-select">{{ 'STRINGS.LOAD_MORE' | translate | uppercase }}</span>
      </div>
    </div>
  -->

  @if (isLoading()) {
    <ic-waiting-indicator
      [isVisible]="isLoading()"
      backgroundColor="transparent"
    ></ic-waiting-indicator>
  }

</div>
